import Vue from 'vue'
const state = () => (localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : {
  cartList: [],
})


const getters = {
  getTotal: (state) => state.cartList.reduce((total, prev) => total += (Number.parseFloat(prev.price) * prev.quantity).toFixed(2) - 0, 0)
}

const actions = {

}

const mutations = {
  addCart (state, cart) {
    Vue.prototype.$bus.$emit('showCart')
    const cartArr = JSON.parse(JSON.stringify(cart))
    /* 只允许存在 shippingRequired 相等的coupon */
    state.cartList = state.cartList.filter(item => item.shippingRequired === cartArr.shippingRequired)
    console.log(state.cartList)
    // 查找是否存在
    const index = state.cartList.findIndex(item => item.couponId === cartArr.couponId)
    if (index !== -1) {
      // 存在,数量++
      state.cartList[index].quantity++
    } else {
      // 不存在，直接增加商品
      cartArr.quantity = 1
      state.cartList.push(cartArr)
    }
    // 取出缓存
    const localCart = JSON.parse(localStorage.getItem('cart'))
    if (localCart && localCart.cartList) {
      // 取出来缓存，将缓存中所有 shippingRequired 相反的值都删了
      localCart.cartList = localCart.cartList.filter(item => item.shippingRequired === cartArr.shippingRequired)
      const localIndex = localCart.cartList.findIndex(item => item.couponId === cartArr.couponId)
      if (localIndex !== -1) {
        localCart.cartList[localIndex].quantity++
      } else {
        localCart.cartList.push(cartArr)
      }
      localStorage.setItem('cart', JSON.stringify(localCart))
    } else {
      localStorage.setItem('cart', JSON.stringify(state))
    }
  },
  // 增加商品
  increaseCart (state, cart) {
    const cartArr = JSON.parse(JSON.stringify(cart))
    const index = state.cartList.findIndex(item => item.couponId === cartArr.couponId)
    if (index !== -1) {
      // 存在
      state.cartList[index].quantity++
      console.log('增加后的数量:', state.cartList[index].quantity)
      // 取出缓存
      const localCart = JSON.parse(localStorage.getItem('cart'))
      if (localCart && localCart.cartList) {
        const localIndex = localCart.cartList.findIndex(item => item.couponId === cartArr.couponId)
        if (localIndex !== -1) {
          // 只有存在的情况下才能进行操作
          localCart.cartList[localIndex].quantity++
          localStorage.setItem('cart', JSON.stringify(localCart))
        }
      }
    }
  },
  // 减少商品
  reduceCart (state, cart) {
    const cartArr = JSON.parse(JSON.stringify(cart))
    const index = state.cartList.findIndex(item => item.couponId === cartArr.couponId)
    if (index !== -1 && cart.quantity !== 1) {
      // 存在 且 数量不能少于1
      state.cartList[index].quantity--
      // 取出缓存
      const localCart = JSON.parse(localStorage.getItem('cart'))
      if (localCart && localCart.cartList) {
        const localIndex = localCart.cartList.findIndex(item => item.couponId === cartArr.couponId)
        if (localIndex !== -1) {
          // 只有存在的情况下才能进行操作
          localCart.cartList[localIndex].quantity--
          localStorage.setItem('cart', JSON.stringify(localCart))
        }
      }
    }
  },
  // 删除商品
  removeCart (state, { id }) {
    const index = state.cartList.findIndex(item => item.couponId === id)
    if (index !== -1) {
      state.cartList.splice(index, 1)
    }
    const localCart = JSON.parse(localStorage.getItem('cart'))
    if (localCart && localCart.cartList) {
      const localIndex = localCart.cartList.findIndex(item => item.couponId === id)
      if (localIndex !== -1) {
        localCart.cartList.splice(localIndex, 1)
        localStorage.setItem('cart', JSON.stringify(localCart))
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}